import { createContext } from "react";

const context = createContext("Roma");

export const { Consumer, Provider } = context;
export default context;
